import { render, staticRenderFns } from "./SurchargeEmails.vue?vue&type=template&id=c9d7a7ca"
import script from "./SurchargeEmails.vue?vue&type=script&lang=js"
export * from "./SurchargeEmails.vue?vue&type=script&lang=js"
import style0 from "./SurchargeEmails.vue?vue&type=style&index=0&id=c9d7a7ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports